import { GetterTree } from 'vuex';
import { ConfigState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { ComponentsGetter } from './getters/components.getter';
import { ConfigGetter } from './getters/config.getter';
import { CoreComponentsGetter } from './getters/core-components.getter';
import { CurrencyGetter } from './getters/currency.getter';
import { FacetGetter } from './getters/facet.getter';
import { FacetsGroupsGetter } from './getters/facets-groups.getter';
import { FacetsGetter } from './getters/facets.getter';
import { MessagesGetter } from './getters/messages.getter';
import { PreFacetsGetter } from './getters/pre-facets.getter';
import { ResultsGetter } from './getters/results.getter';
import { URLConfigGetter } from './getters/url.getter';

export const CONFIG_GETTERS: GetterTree<ConfigState, RootStoreState> = {
  ...new ConfigGetter().getters,
  ...new ComponentsGetter().getters,
  ...new CurrencyGetter().getters,
  ...new FacetsGroupsGetter().getters,
  ...new FacetGetter().getters,
  ...new FacetsGetter().getters,
  ...new MessagesGetter().getters,
  ...new URLConfigGetter().getters,
  ...new CoreComponentsGetter().getters,
  ...new PreFacetsGetter().getters,
  ...new CoreComponentsGetter().getters,
  ...new ResultsGetter().getters
};
